module.exports = __webpack_public_path__ + "20bd6f7b3e2b12f56556a98412af6ecc.svg";